import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MdrPassenger, MdrRequestPassengers } from 'src/app/model/mdr.model';

const RELATION_LABELS: Record<MdrPassenger['relation'], string> = {
  REQUESTER: 'Requester',
  SAME_CABIN: 'Same cabin',
  SAME_BOOKING: 'Same BN Requester',
  DINING_WITH: 'Dining with',
  EXTRA_CABIN: 'Extra',
  SAME_BOOKING_EXTRA: 'Same BN Extra',
  DINING_WITH_EXTRA: 'Dining with extra',
};

const STATUS_LABELS: Record<MdrPassenger['status'], string> = {
  UNCHANGED: '= unchanged',
  EXCLUDED: '- excluded',
  ADDED: '+ added'
};

@Component({
  selector: 'app-mdr-passengers-modal',
  templateUrl: './mdr-passengers-modal.component.html',
  styleUrls: ['./mdr-passengers-modal.component.scss'],
  standalone: false
})
export class MdrPassengersModalComponent {

  displayedColumns: string[] = [
    'relation', 'booking_number', 'cabin',
    'dining_with_code', 'language', 'passenger_name', 'status'
  ];

  constructor(
    public dialogRef: MatDialogRef<MdrPassengersModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MdrRequestPassengers
  ) {}

  relationLabel(relation: MdrPassenger['relation']): string {
    return RELATION_LABELS[relation] ?? relation;
  }

  statusLabel(status: MdrPassenger['status']): string {
    return STATUS_LABELS[status] ?? status;
  }

  close(): void {
    this.dialogRef.close();
  }
}
